import { insurerCompaniesService, type InsurerCompany } from '@/services/insurer-companies';
import { useQuery } from '@tanstack/react-query';

export function useInsurerCompanies() {
  return useQuery<InsurerCompany[], Error>({
    queryKey: ['insurer-companies'],
    queryFn: async () => {
      const response = await insurerCompaniesService.list();

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao carregar congêneres');
      }

      return response.data;
    },
    staleTime: 5 * 60 * 1000,
  });
}
